var map = {
	"./agriculture.jpg": "2ba6",
	"./constructionMachineryOtr.jpg": "8b45",
	"./motorcycles.jpg": "dc31",
	"./pkw.jpg": "804a",
	"./trucksAndBuses.jpg": "5441"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8196";